/**
 * The tab a person last used in each hub (the Navigation review, slice (c)), kept in their browser: the menu's item and
 * the hub's own address open it next time, so a task a person repeats takes no more clicks than before its page became
 * a tab. Kept per person, so another person on the same browser starts from the hub's first tab. Storage that refuses
 * keeps nothing, and the hub opens on its first tab, as before. This module imports nothing.
 */

const PREFIX = "forge.hub.";
const TAB_ID = /^[\w-]{1,32}$/;

function key(person: string, hub: string): string {
  return `${PREFIX}${hub}.${person}`;
}

/** Keeps the tab a person opened in a hub; nothing without a person, or for a tab id that is not one. */
export function rememberHubTab(person: string, hub: string, tab: string): void {
  if (!person || !TAB_ID.test(tab)) return;
  try {
    localStorage.setItem(key(person, hub), tab);
  } catch {
    // Storage blocked: the hub opens on its first tab, as before.
  }
}

/** The tab a person last opened in a hub; null for none, or a value this module did not write. */
export function lastHubTab(person: string, hub: string): string | null {
  if (!person) return null;
  try {
    const tab = localStorage.getItem(key(person, hub));
    return tab && TAB_ID.test(tab) ? tab : null;
  } catch {
    return null;
  }
}
